<template>
  <b-container class="main-content code-page">
    <b-form @submit="onSubmit">
      <b-form-group id="input-group-2" label="Zugangscode" label-for="code">
        <b-form-input
          id="code"
          v-model="code"
          required  minlength="16" maxlength="16"
        ></b-form-input>
      </b-form-group>
      <b-button type="submit" variant="primary">Weiter</b-button>
    </b-form>
  </b-container>
</template>

<script>
export default {
  name: 'Code',
  data() {
    return {
      code: '',
    };
  },
  props: ['id'],
  methods: {
    onSubmit() {
      this.$router.push({ name: 'abstimmung', params: { id: this.id, code: this.code } });
    },
  },
};
</script>

<style scoped>

</style>
